import { render, staticRenderFns } from "./Colecoes.vue?vue&type=template&id=8cd846f4&scoped=true&"
import script from "./Colecoes.vue?vue&type=script&lang=js&"
export * from "./Colecoes.vue?vue&type=script&lang=js&"
import style0 from "./Colecoes.vue?vue&type=style&index=0&id=8cd846f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd846f4",
  null
  
)

export default component.exports